<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="姓名/工号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.person">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="成本中心" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.cost">
                        </el-input>
                    </el-form-item>
                </el-col>


                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="人员成本中心">
                <el-button :loading="!!loading" v-authority="'BACK_MENU5_M1_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>

                <el-button v-authority="'BACK_MENU5_M1_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table v-loading="loading" :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="tableTotal">
                <el-table-column prop="person" label="姓名/工号" />
                <el-table-column prop="cost" label="成本中心" />


                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">

                        <el-button v-authority="'BACK_MENU5_M1_B3'" type="danger" @click="deleteRow(scope.row.pcId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" :model="mainObj" @open="open" :style="$popups.popups(0.5,0.6)" class="fromDialog">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-col :lg="8" :xl="8">
                        <el-form-item label="姓名/工号" prop="person" class="EL-Form-Item">
                            <el-input v-model.trim="mainObj.person" maxlength="20"> </el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item label="成本中心" prop="cost" class="EL-Form-Item">
                            <el-input v-model="mainObj.cost" maxlength="5"> </el-input>
                        </el-form-item>
                    </el-col>


                </el-form>
            </span>
            <span slot="footer" class="dialog-footer footer-bottom">
                <el-button size="small" type="info" @click="editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <!--<el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>-->
            </span>
        </el-dialog>

      <el-dialog title="导入" :visible.sync="importInShow" class="fromDialog" :close-on-click-modal="false" :show-close="false" @click.stop :style="$popups.popups(0.8,0.9)">
        <div class="uploader-div" >
          <el-upload
              :action="action"
              :file-list="fileList"
              :limit="1"
              multiple
              :accept="accept"
              :before-upload="handleBeforeUpload"
              :on-error="handleUploadError"
              :on-exceed="handleExceed"
              :on-success="handleUploadSuccess"
              :on-change="handChange"
              :http-request="httpRequest"
              :show-file-list="true"
              :auto-upload="false"
              class="upload-file-uploader"
              ref="upload"
          >
            <!-- 上传按钮 -->
            <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            <el-button style="margin-left: 10px;" :disabled="fileList.length < 1" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
            <!-- <el-button  @click="rePrintBarcode()" class="btn-t-edit">标签打印</el-button> -->
          </el-upload>
        </div>
        <div slot="footer" class="dialog-footer footer-bottom">
          <el-button @click="importInShow = false" type="info" class="btn-t-info">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
export default {
    name: "StockCheckTaskDetail",
    data() {
        return {
            headerCellStyle: () => {
                return "background-color: #1f5cec";
            },
          importInShow: false,
          accept: '',
          fileList: [],
          action: 'action',
          // 大小限制(MB)
          fileSize: 20,
          // 文件类型
          fileType:  ".xlsx",
          // 是否显示提示
          isShowTip: {
            type: Boolean,
            default: true
          },
          importData: {
            data: [],
            pageNum: 1,
            pageSize: 500000,
            total: 0,
            printTwo: false,
            headerCellStyle: () => {
              return "background-color: #1f6cec";
            },
          },
            form: {},
            rules: {
                person: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],
                cost: [{
                    required: true,
                    message: "请输入",
                    trigger: "blur",
                }, ],

                // mtType: [{
                //     required: true,
                //     message: "请输入",
                //     trigger: "blur",
                // }, ],
                // validityMonth: [{
                //     required: true,
                //     message: "请输入",
                //     trigger: "blur",
                // }, ],
            },

            mtTypeList: [], //物料类型集合

            showRoleBox: true,
            add_or_edit: Boolean, //新增|编辑
            editBoxShow: false, //编辑框
            dialogFormVisible: false,
            formLabelWidth: "140px", // 对话框大小
            tableHeight: 0, //表格高度
            testValue: 1,
            mainObj: {},
            pagination: {
                pageSize: 50,
                pageNum: 1,
                person: "",
                cost: "",
                fcCode: localStorage.getItem("fcCode") || "",

            },
            tableTotal:0,
            mainData: [],
            fcode: localStorage.getItem("fcCode") || "",

            downloadLoading: false, //下载中

            loading: 0,

            logContent: "", //操作日志-内容
            logRemarks: "", //操作日志-备注
            // 输入框延时加载
            isSetTimeout: null,
        };
    },
    watch: {
        pagination: {
            handler(newVal) {
                clearTimeout(this.isSetTimeout)
                this.isSetTimeout = setTimeout(() => {
                    this.getAuxiMaterialData(newVal);
                }, 1000)
            },
            deep: true,
        },
    },
    methods: {
      httpRequest(param) {

        var formData = new FormData();
        formData.append("file", param.file);
        this.$http
            .request({
              url: "/api/material/importExcel",
              method: "POST",
              headers: {
                "Content-Type": "multipart/form-data",
                "X-Auth-Token": localStorage.getItem('token')
              },
              showLoading: true,
              data: formData,
            })
            .then((res) => {
              if (res.status === 100) {
                this.importData.data = res.data.list || [];
                this.$notify({
                  message: "上传成功!",
                  type: "success",
                });
                this.getAuxiMaterialData();
              } else {
                this.$notify({
                  message: res.message,
                  type: "danger",
                });
              }
            });

      },
      // 上传前校检格式和大小
      handleBeforeUpload(file) {
        // 校检文件类型
        if (this.fileType) {
          let fileExtension = "";
          if (file.name.lastIndexOf(".") > -1) {
            fileExtension = file.name.slice(file.name.lastIndexOf("."));
          }
          const isTypeOk =  this.fileType.indexOf(fileExtension) != -1 ? true:false;

          if (!isTypeOk) {
            this.$message.error(`文件格式不正确, 请上传${this.fileType}格式文件!`);
            return false;
          }
        }
        // 校检文件大小
        if (this.fileSize) {
          const isLt = file.size / 1024 / 1024 < this.fileSize;
          if (!isLt) {
            this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
            return false;
          }
        }
        return true;
      },
      // 获取文件名称
      getFileName(name) {
        if (name.lastIndexOf("/") > -1) {
          return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
        } else {
          return "";
        }
      },
      /** 手动提交上传 */
      submitUpload() {
        if (this.fileList.length <= 0) {
          return false
        }
        this.$refs.upload.submit()
      },
      /** 文件状态改变时调用 */
      handChange(file, fileList) {
        this.fileList = fileList
      },
      // 删除文件
      handleDelete(index) {
        this.fileList.splice(index, 1);
      },
      // 文件个数超出
      handleExceed() {
        this.$message.error(`只允许上传1个文件`);
      },
      // 上传失败
      handleUploadError(err) {
        this.$message.error("上传失败, 请重试");

      },

      // 上传成功回调

      handleUploadSuccess(res, file) {
        this.$message.success("上传成功");
        this.getTableData();
        this.cancel()

      },
        //获取数据
        getAuxiMaterialData() {
            // this.loading++
            this.$http
                .request({
                    url: "/api/personCost/getPsersonCost",
                    method: "GET",
                    params: this.pagination,
                })
                .then((resp) => {
                    // this.loading--
                    if (resp.status == 100) {
                        // console.log(resp.data.list.length);
                        this.mainData = resp.data.list || [];
                        this.tableTotal = resp.data.total;
                    }
                })
                .catch((error) => {
                    // this.loading--;
                });
        },
        //获取类型
        getmtTypeList() {
            this.$http.request({
                url: "/api/dictData/getDictData",
                method: "GET",
                showLoading: true,
                params: {
                    ddCode: "MDTYPE",
                },
            }).then((resp) => {
                if (resp.status == 100) {
                    this.mtTypeList = resp.data.list || [];
                }
            }).catch((error) => {});
        },

        //表单验证
        submitForm(formName) {
            let r = Boolean;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    r = true;
                } else {
                    r = false;
                }
            });
            return r;
        },
        //框打开
        open() {
            if (this.add_or_edit) {
                //新增
                this.mainObj = JSON.parse(JSON.stringify({}));
            } else {
                this.getAuxiMaterialData();
            }
        },
        //新增
        add() {
            if (this.fcode != "") {
                this.mainObj.fcCode = this.fcode;
            }
            if (this.submitForm("mainObj")) {
                this.$http
                    .request({
                        url: "/api/personCost/insertPsersonCost",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：物料新增成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：物料新增失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //编辑
        editRow() {
            if (this.submitForm("mainObj")) {
                if(this.mainObj.minBoxNum == undefined){
                  this.mainObj.minBoxNum = "";
                }
                this.$http
                    .request({
                        url: "/api/material/updateMaterial",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "修改成功！",
                                type: "success",
                            });
                            this.logRemarks = "material：物料编辑成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "material：物料编辑失败";
                        }
                        this.logContent =
                            "mtCode：" +
                            this.mainObj.mtCode +
                            "\t mtName" +
                            this.mainObj.mtName;
                        this.systemLog();
                        this.editBoxShow = false;
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            }
        },
        //删除
        deleteRow(pcId) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "删除",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .request({
                            url: "/api/personCost/deleteId",
                            method: "DELETE",
                            showLoading: true,
                            params: {
                                pcId: pcId,
                            },
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "删除成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料删除成功";
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: "删除失败",
                                });
                                this.logRemarks = "material：物料删除失败";
                            }
                            this.logContent = "mtId：" + pcId;
                            //this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            // this.$notify.error({
                            //     title: "失败",
                            //     message: "调用失败",
                            // });
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },

        //重置
        resetData() {
            this.pagination = {
                pageSize: 50,
                pageNum: 1,
                mtCode: "",
                mtName: "",
                fcCode: localStorage.getItem("fcCode"),
            };
            this.tableTotal=0;
            // this.getAuxiMaterialData();
        },

        //表格导出
        downLoadFile() {
            this.downloadLoading = true;
            var paramsObj = {
                person: this.pagination.person,
                cost: this.pagination.cost,

                pageNum: 1,
                pageSize: 999999,
            }

            this.$http.request({
                url: '/api/personCost/getPsersonCost',
                method: 'GET',
                showLoading: true,
                params: paramsObj
            }).then((resp) => {
                resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                    message: '查询失败'
                });
            })
        },
        downLoad(list) {
            import('@/libs/Export2Excel').then(excel => {
                list.forEach(function(c) {
                    if (c.mtCheck == '10') {
                        c['mtCheck'] = '全检'
                    } else if (c.mtCheck == '20') {
                        c['mtCheck'] = '免检'
                    } else if (c.mtCheck == '30') {
                        c['mtCheck'] = '抽检'
                    }

                    if (c.mtXa == true) {
                        c['mtXa'] = '是'
                    } else if (c.mtXa == false) {
                        c['mtXa'] = '否'
                    }
                })
                const tHeader = ['姓名/工号', '成本中心']
                const filterVal = ['person', 'cost']
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                    header: tHeader,
                    data,
                    filename: '物料数据'
                })
                this.logContent = "导出"
                this.logRemarks = "sys_material：导出人员成本数据"
                this.systemLog();
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },


        /**
         * 操作日志
         */
        systemLog() {
            let objData = {
                logType: "物料主数据",
                logContent: this.logRemarks || "",
                //logRemarks: this.logRemarks || "",
                logUser: localStorage.getItem("user") || "",
            };
            this.$http
                .request({
                    url: "api/log/insert",
                    method: "POST",
                    data: objData,
                })
                .then((resp) => {
                    this.logContent = "";
                    this.logRemarks = "";
                    if (resp.status == 100) {}
                })
                .catch((error) => {});
        },
    },
    activated() {
        this.getmtTypeList()
        /* 获取首页的数据 */
        this.getAuxiMaterialData();
    },
};
</script>

<style scoped>
</style>